module.exports = __webpack_public_path__ + "static/img/shankar.caca18b7.jpg";